module.exports = __webpack_public_path__ + "icomoon.ccd4464d14723178bfd3.ttf";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/assets/fonts/icomoon.ttf?mm9zby
// module id = ../../../../../src/assets/fonts/icomoon.ttf?mm9zby
// module chunks = styles